import React from 'react'

const ClockSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14.6 14.6'
    >
      <g id='clock-0900-svgrepo-com' transform='translate(-2.529 -2.488)'>
        <circle
          id='Ellipse_226'
          data-name='Ellipse 226'
          cx='7'
          cy='7'
          r='7'
          transform='translate(2.829 2.788)'
          fill='none'
          stroke='#000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='0.6'
        />
        <path
          id='Path_3159'
          data-name='Path 3159'
          d='M8.771,6v4.61H6'
          transform='translate(1.142 -0.695)'
          fill='none'
          stroke='#000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='0.6'
        />
      </g>
    </svg>
  )
}

export default ClockSvg
